import { observer } from 'mobx-react-lite';
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import CheckIcon from "@mui/icons-material/CheckCircleOutline"
import { useProposalsViewProposalStore } from '../ProposalsViewProposalStore';
import ProposalSigneeChip from './ProposalSigneeChip';
import { themeConfig }from '@gap/shared/theme';

export default observer(function ProposalSignedConfirmation() {
   const proposalsViewProposalStore = useProposalsViewProposalStore()
   const { isProposalAccepted, numSignaturesRemaining, signeesSortedByAgreedAt } = proposalsViewProposalStore

   return <Stack sx={{
      py: 7,
      px: 2,
      alignItems: 'center',
      textAlign: 'center',
      gap: 5.5,
   }}>
      <CheckIcon sx={{ fontSize: '48px', color: '#43A047' }} />
      <Typography variant="h3" sx={{ fontWeight: 'bold' }}>You’ve finished signing!</Typography>
      {isProposalAccepted
         ? <Stack sx={{ gap: 2, alignItems: 'center' }}>
            <Typography variant="subtitle1" sx={{ color: themeConfig.primary[600] }}>
               This proposal has been accepted and a signed copy has been emailed to you.
            </Typography>
            <Button variant="contained" onClick={proposalsViewProposalStore.navigateToSignedDocument}>View accepted proposal</Button>
         </Stack>
         : <Stack sx={{ gap: 3 }}>
            <Typography variant="subtitle1" sx={{ color: themeConfig.primary[600] }}>
               You’ll receive a signed copy once everyone has signed.
            </Typography>
            <Typography variant="subtitle1" sx={{ color: themeConfig.primary[600] }}>
               You can now safely close this window.
            </Typography>
         </Stack>
      }
      <Stack sx={{ gap: 1, alignItems: 'center' }}>
         <Stack sx={{ gap: .5, flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'start' }}>
            {signeesSortedByAgreedAt.map((signee) => (
               <ProposalSigneeChip name={signee.name} hasSigned={!!signee.agreedAt} key={signee.id} />
            ))}
         </Stack>
         <Typography variant="body2" sx={{ color: themeConfig.primary[600] }}>
            {isProposalAccepted
               ? <>All required signatures have been received.</>
               : <>{numSignaturesRemaining} more {numSignaturesRemaining === 1 ? 'signature is' : 'signatures are'} required
                  for this proposal to be accepted.</>}
         </Typography>
      </Stack>
   </Stack>
})